<template>
  <div id="app" 
    :class="['mainwrapper', {'menuopen' : showmenu}]">
    
    <div class="contentwrapper">
      <div 
        v-if="
          $route.name != 'login' &&
          $route.name != 'register' &&
          $route.name != 'forgotpassword' &&
          $route.name != 'resetpassword'
          "
        class="fzmHeader-home">
        <holes-header :showmenu.sync="showmenu" />
      </div>

      <router-view/>
    </div>

    <side-menu 
      :showmenu.sync="showmenu"
      v-show="showmenu"/>
  </div>
</template>

<script>
/**
 * Declerations
 */

// mixins
import {crontabmixins} from '@/mixins/crontab'
import {socketio} from '@/mixins/socketio'

// Components
import Header from '@/components/header.vue';
import sidemenu from '@/components/sidemenu.vue'

export default {
    mixins : [crontabmixins, socketio],
    data() {
      return {
        showmenu : false
      }
    },
    components: {
      'holes-header': Header,
      'side-menu'   : sidemenu
    },
    computed : {
      /**
       * User session status
       */
      islogin() {
        return this.$store.state.islogin
      }
    },
    /**
     * Run function before components redered
     */
    async beforeMount() {
        // connect to socket io
        this.initsocket();

        // Get user
        await this.$store.dispatch('getUser');
        /**
         * Run only if user / customer is loggedin
         */
        if(this.islogin) {
          // Get subscription
          this.$store.dispatch('getSubscriptions');
          // Get settings
          this.$store.dispatch('getsettings');

        }
    },
    /**
     * Run functions after rendered
     */
    mounted() {
      // Cron job iniattion
      this.initCron();
    }
}
</script>

<style lang="scss">
  @import '@/scss/app.scss';

  .form-control {
    .btn {
      font-size : 12px;
    }
  }

  .mainwrapper {
    display: flex;

    .contentwrapper {
      width      : 100vw;
    }

    &.menuopen {

      .contentwrapper {
        margin-left: -300px;
        height     : 100vh;
        overflow   : hidden;
      }

      .navbarMainWrapper {
        left : -310px;
        width: 100vw;
      }
    }
  }
</style>

